import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.giveaway;

export const giveawaysListSelector = createSelector(getState, (state) => state.giveaways);
export const giveawaysMetaDataSelector = createSelector(getState, (state) => state.metaData);

export const isLoadingGivewaySelector = createSelector(getState, (state) => state.isLoadingGiveway);

export const participiantsListSelector = createSelector(getState, (state) => state.participiants);
export const participiantsMetaSelector = createSelector(
  getState,
  (state) => state.participiantsMeta
);

export const isLoadingParticipiantsSelector = createSelector(
  getState,
  (state) => state.isLoadingParticipiants
);

export const isPickingWinnerSelector = createSelector(getState, (state) => state.isPickingWinner);

export const isRerollingWinnerSelector = createSelector(
  getState,
  (state) => state.isRerollingWinner
);
